import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { FmcgIndustryPageBG } from "@/components/site/FmcgIndustryPageBG";
import { FMCG_META_DESCRIPTION_BG } from "@/content/meta/FmcgIndustryPageBG";

export const Route = createFileRoute("/bg/industries/fmcg")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и анализи за FMCG | Perceptica" },
      { name: "description", content: FMCG_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медиен мониторинг и анализи за FMCG | Perceptica" },
      { property: "og:description", content: FMCG_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и анализи за FMCG | Perceptica" },
      { name: "twitter:description", content: FMCG_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries/fmcg" },
      ...ogImageMeta("bg", "/industries/fmcg"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries/fmcg" }),
  }),
  component: FmcgIndustryPageBG,
});
